import './objetivos.css'
import { useReveal } from "../../hooks/useReveal";
import missao from "../../img/missao.png"
import servico from "../../img/servico.png"
import visao from "../../img/visao.png"

function Objetivos() {

    useReveal('#missao', { duration: 500, distance: "90px", delay:300, reset: false});
    useReveal('#visao', { duration: 500, distance: "90px", delay:500, reset: false});
    useReveal('#servico', { duration: 500,distance: "90px", delay:700, reset: false});
    useReveal('.buttonServicos', { duration: 500, delay:700, reset: false});

    return (
        <section>
            <div className='containerObjetivos'>
                <div id='missao' className='boxObjetivos'>
                    <img src={missao} alt = "Imagem Missao"/>
                    <h1>MISSÃO</h1>
                    <p>Oferecer serviços contábeis com excelência e ética, sempre focando em soluções eficazes para as necessidades de cada cliente.</p>
                </div>
                <div id='visao' className='boxObjetivos'>
                    <img src={visao} alt = "Imagem Visao"/>
                    <h1>VISÃO</h1>
                    <p>Nosso propósito é ser uma contabilidade que vai além dos números, que compreende de forma humana, atenta e empática as necessidades reais de cada cliente, oferecendo soluções práticas e personalizadas.</p>
                </div>
                <div id='servico' className='boxObjetivos'>
                    <img src={servico} alt = "Imagem Servico"/>
                    <h1>POR QUE CONTRATAR NOSSOS SERVIÇOS?</h1>
                    <ul>
                        <li>  Equipe especializada e preparada pra te ajudar</li>
                        <li>  Experiência e dedicação</li>
                        <li>  Suporte contábil de qualidade</li>
                    </ul>
                </div>
            </div>

            <div className='buttonServicos'>
                <a href='#servicos'>SERVIÇOS</a>
            </div>
        </section>
    );
};

export default Objetivos;